import ContactProfileImage from '@app/components/ContactProfileImage'
import { IComment } from '@app/models/Comment'
import { ICurrentUserState } from '@app/store/modules/account'
import { EditorState } from 'draft-js'
import * as React from 'react'
import CommentItemBody from './CommentItemBody'
import CommentItemEditBody from './CommentItemEditBody'
import CommentItemFooter from './CommentItemFooter'
import CommentItemHeader from './CommentItemHeader'

interface ICommentListItemProps {
  beginEdit: (feedItemId: string, commentId: string) => void
  cancelEdit: (feedItemId: string, commentId: string) => void
  deleteComment: (feedItemId: string, commentId: string) => void
  item: IComment
  saveEditComment: (feedItemId: string, comment: IComment) => void
  setIsPublic: (
    feedItemId: string,
    commentId: string,
    isPublic: boolean,
  ) => void
  setMarkup: (
    feedItemId: string,
    commentId: string,
    markupState: EditorState,
  ) => void
  toggleFavorite: (
    feedItemId: string,
    commentId: string,
    userId: string,
    favorite: boolean,
  ) => void
}

type CommentListItemProps = ICommentListItemProps & ICurrentUserState

export default class CommentListItem extends React.PureComponent<
  CommentListItemProps
> {
  public render() {
    return (
      <li className='comment d-flex mb-3'>
        <ContactProfileImage
          contact={this.props.item.author.contactId}
          size={25}
        />
        <div className='mr-2' />
        <div className='flex-grow-1'>
          <CommentItemHeader
            beginEdit={this.props.beginEdit}
            deleteComment={this.props.deleteComment}
            item={this.props.item}
            user={this.props.user}
          />
          {this.props.item.isEditing
            ? this._renderEditMode()
            : this._renderViewMode()}
        </div>
      </li>
    )
  }

  private _renderEditMode() {
    return (
      <CommentItemEditBody
        cancelEdit={this.props.cancelEdit}
        item={this.props.item}
        saveEditComment={this.props.saveEditComment}
        setIsPublic={this.props.setIsPublic}
        setMarkup={this.props.setMarkup}
      />
    )
  }

  private _renderViewMode() {
    return (
      <div>
        <CommentItemBody item={this.props.item} />
        <CommentItemFooter
          item={this.props.item}
          toggleFavorite={this.props.toggleFavorite}
        />
      </div>
    )
  }
}
